// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federfestigkeit/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federfestigkeitDE: PageEntry = {
  id: "post.federfestigkeit",
  locale: "de",
  slug: "federfestigkeit",
  seo: {
    title: "Glossar: Federfestigkeit einfach erklärt | Dietz GmbH",
    description: "Die Federfestigkeit bezieht sich auf die Fähigkeit einer Feder, Belastungen und Verformungen standzuhalten, ohne dauerhafte Schäden zu erleiden. Dieser Parameter ist entscheidend f",
  },
  type: "post",
  h1: "Glossar: Federfestigkeit einfach erklärt",
  intro: "Die Federfestigkeit bezieht sich auf die Fähigkeit einer Feder, Belastungen und Verformungen standzuhalten, ohne dauerhafte Schäden zu erleiden. Dieser Parameter ist entscheidend für die Lebensdauer und Zuverlässigkeit einer Feder in einem bestimmten System. Die Festigkeit einer Feder hängt von verschiedenen Faktoren ab, darunter das verwendete Federmaterial, die Federkonstruktion und die Qualität der Fertigung. Eine genaue Kenntnis der Federfestigkeit ermöglicht es Ingenieuren, Federn so auszulegen, dass sie den spezifischen Anforderungen einer Anwendung gerecht werden und gleichzeitig eine lange Lebensdauer gewährleisten.",
  blocks: [

  ],
};
